import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState = () => (
  <div className="flex items-center justify-center h-96">
    <div className="text-center">
      <Loader2 className="h-8 w-8 animate-spin text-indigo-600 mx-auto mb-4" />
      <p className="text-gray-600">Loading transmission data...</p>
    </div>
  </div>
);

export default LoadingState;
